import { Box, Stack, Typography } from "@mui/material";

import { InfoPanel } from "../../subs/InfoPanel";
import { PageSection } from "../../subs/PageSection";

export const TestingInfo = () => { 
    return (<Stack direction={"column"}>
        <Typography variant={"h5"} marginTop={20}>{"Welcome to the test page. This is where you will spend most of your time."}</Typography>
                <Box>
                    <PageSection>
                        <InfoPanel heading={"Finding Products to Test"}>
                            {[<ul>
                                <li>{"All products that are available for testing with your products are available in the navigation on the left."}</li>
                                <li>{"Products are grouped by OPC Technology / Interface."}</li>
                                <li>{"Expand on the \"folders\" to find and select a product to test against."}</li>
                            </ul>]}
                        </InfoPanel>
                        <InfoPanel heading={"Testing Process"}>
                            {[<ul>
                                <li>{"At the top of the test page you will find the product details and vendor details."}</li>
                                <li>{"Work through the test-cases within that page and feedback your results into the form."}</li>
                                <li>{"When finished with the test, click the \"submit\" button  at the bottom."}</li>
                            </ul>]}
                        </InfoPanel>
                    </PageSection>
            
                    <PageSection>
                        <InfoPanel heading={"Product Functionality"}>
                                {[<ul>
                                    <li>{"Test cases will appear bases on the functionality your product claims to support."}</li>
                                    <li>{"Go back to the \"Testing\" tab and click on \"Supported Features\""}</li>
                                </ul>]}
                        </InfoPanel>
                        <InfoPanel heading={"Reviewing Test Results"}>
                                {[<ul>
                                    <li>{"Client vendors: Click on \"Finalize\" found at the bottom of the test screen to close testing for a product."}</li>
                                    <li>{"Server vendors: Find your product to the left, and look for Clients that have red/yellow labels."}</li>
                                </ul>]}
                        </InfoPanel>
                    </PageSection>
                </Box>
        </Stack>)
}